import { createTheme } from '@mui/material';

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#009c84',
    },
    secondary: {
      main: '#181818',
    },
  },
  typography: {
    fontFamily: 'figtree',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '16px',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: '12px',
          boxShadow: '0px 4px 10px 0px #00000026',
        },
      },
    },
  },
});
